<!-- 调研问卷 -->
<template>
  <div class="survey" v-if="surveyShow">
    <div class="title flex flexBetween fbold">调研问卷<img src="https://q-fe.aixuexi.com/cloud/english-word/1724901265546-ac6b6d2f89cc:close.png" alt="" class="closeIcon" @click="closeHandle()" /></div>
    <div class="content">
      <div v-if="Array.isArray(curLevelData.options) && curLevelData.options.length > 0" >
        <ol :start="answerIndex + 1" class="optionTitle mab18 fbold">
          <li class="wordWrap">{{ curLevelData.questionText }}{{ curLevelData.questionType !== 1 ? '（可多选）' : ''}}</li>
        </ol>
        <div class="options multiple flex flexStart flexWrap">
          <div :class="{
            item: true,
            itemAuto: curLevelData.options.length <= 2,
            flex: true,
            flexStart: !!item.icon,
            itemNoImg: !item.icon,
            curIndex: selectedIndex.includes(index)
          }" @click="optionSelectHandle(item, index)" v-for="(item, index) in curLevelData.options" :key="index">
            <img :src="item.icon" alt="" class="optionsImg" v-if="item.icon" />
            <span class="wordWrap">{{ item.optionText }}</span>
          </div>
        </div>
        <div class="textareaWrap" v-if="this.needText">
          <textarea class="textarea" maxlength="200" rows="4" placeholder="写下你的建议吧" v-model="answerText" />
        </div>
      </div>
    </div>
     <div class="bottom flex flexEnd" v-if="curLevelData.questionType !== 1 || needText || (curLevelData.questionType === 1 && isLastIndex && selectedIndex.length > 0)">
      <div :class="{
        submitBtn: true,
        flex: true,
        submitBtnDis: selectedIndex.length <= 0
      }" @click="submitBtnHandle">{{ isLastIndex ? '提交' : '下一步' }}</div>
    </div>
  </div>
</template>
<script>
import cookies from 'js-cookie';

const userIdCookies = `surveyHidden${cookies.get('userId')}`;
const props = {
  position: {
    type: Number,
    default: 1,
  },
};
export default {
  props,
  data() {
    return {
      surveyShow: false,
      answerIndex: 0,
      answerText: 0,
      questionnaireInfo: null,
      selectedList: [],
      selectedIndex: [],
      levelData: [],
      surveyIsNoShow: null,
    };
  },
  computed: {
    curLevelData() {
      return this.levelData[this.answerIndex] || {};
    },
    isLastIndex() {
      const curLevelData = this.levelData[this.answerIndex] || {};
      const itemList = curLevelData.options ? curLevelData.options.filter((j, i) => this.selectedIndex.includes(i)) : [];
      return !itemList.find((i) => Array.isArray(i.subQuestions) && i.subQuestions.length > 0) && this.answerIndex === this.levelData.length - 1;
    },
    needText() {
      let item = this.levelData[this.answerIndex] || {};
      item = item.options.filter((j, i) => this.selectedIndex.includes(i));
      return item.findIndex((i) => i.inputState === 1) >= 0;
    },
  },
  mounted() {
    this.getDataExternal();
  },
  methods: {
    loggerSurveyHandle(type, value) {
      const loggerHandle = type === 'click' ? this.$track.sendClickLog : this.$track.sendPageLog;
      let loggerId = type === 'click' ? 'AXXWEB_67' : 'AXXWEB_66';
      loggerId = value || loggerId;
      const param = {
        id: this.questionnaireInfo.id || '',
        position: this.position,
        form: '备授课首页',
        time: new Date().getTime(),
      };
      loggerHandle(loggerId, { ...param });
    },
    showHideHandle(val) {
      if (val === this.surveyShow) return;
      if (val) {
        this.getDate().then((res) => {
          if (res) {
            this.surveyShow = val;
            this.loggerSurveyHandle('click');
            this.loggerSurveyHandle('page');
          }
        });
      } else {
        this.surveyShow = val;
      }
    },
    getDataExternal() {
      this.getDate().then((res) => {
        if (!cookies.get(userIdCookies) && res) {
          this.surveyShow = true;
          cookies.set(userIdCookies, true);
          setTimeout(() => {
            this.loggerSurveyHandle('page');
          }, 500);
        }
      });
    },
    getDate() {
      return new Promise((resolve, reject) => {
        this.$service.common.getQuestionnaire({
          positionId: this.position,
        }).then((res) => {
          const { questionnaireInfo, questions } = res;
          this.questionnaireInfo = questionnaireInfo;
          this.levelData = questions;
          this.selectedIndex = [];
          this.selectedList = [];
          this.answerText = '';
          this.answerIndex = 0;
          this.$emit('setAxxSurveyShow', !!(questionnaireInfo && questions));
          resolve(!!questionnaireInfo && questions);
        }).catch((err) => {
          // console.log(err);
          // this.$emit('setAxxSurveyShow', false);
          reject(err);
        });
      });
    },
    closeHandle() {
      cookies.set(userIdCookies, true);
      this.showHideHandle(false);
      this.loggerSurveyHandle('click', 'AXXWEB_68');
    },
    optionSelectHandle(item, index) {
      const getItem = this.curLevelData;
      const getSelectedList = JSON.parse(JSON.stringify(this.selectedList));
      if (getItem.questionType === 1) {
        const { subQuestions } = item;
        if (Array.isArray(subQuestions) && subQuestions.length > 0) {
          const getJson = JSON.parse(JSON.stringify(subQuestions[0]));
          this.levelData.push(getJson);
        }
        if (!this.isLastIndex) {
          this.selectedIndex.push(index);
          this.selectedList.push({
            id: getItem.id,
            options: [item.id],
            text: this.answerText,
          });
          setTimeout(() => {
            this.nextHandle();
          }, 200);
        } else if (!this.selectedIndex.includes(index)) {
          this.selectedIndex = [];
          this.selectedIndex.push(index);
          const findItem = getSelectedList.find((i) => i.id === getItem.id);
          if (findItem) {
            findItem.options = [item.id];
            this.selectedList = getSelectedList;
          } else {
            this.selectedList.push({
              id: getItem.id,
              options: [item.id],
              text: this.answerText,
            });
          }
        } else {
          this.selectedIndex = [];
          const findItem = getSelectedList.find((i) => i.id === getItem.id);
          if (findItem) {
            findItem.options = [];
            this.selectedList = getSelectedList;
          }
        }
      } else if (!this.selectedIndex.includes(index)) {
        this.selectedIndex.push(index);
      } else {
        const findIndex = this.selectedIndex.findIndex((i) => i === index);
        this.selectedIndex.splice(findIndex, 1);
      }
      // console.log('getSelectedList', this.selectedList, this.selectedIndex);
    },
    submitBtnHandle() {
      // const { id, name } = this.questionnaireInfo;
      if (this.selectedIndex.length <= 0) return;
      if (this.curLevelData.questionType === 2) {
        const arr = this.curLevelData.options.filter((j, i) => this.selectedIndex.includes(i) && j.subQuestions);
        this.selectedList.push({
          id: this.curLevelData.id,
          options: this.curLevelData.options.filter((j, i) => this.selectedIndex.includes(i)).map((i) => i.id),
          text: this.answerText,
        });
        if (arr.length > 0) {
          arr.sort((a, b) => b.subQuestions[0].weight - a.subQuestions[0].weight);
          arr.forEach((i, m) => {
            const getJson = JSON.parse(JSON.stringify(i.subQuestions[0]));
            if (m <= 1) this.levelData.push(getJson);
          });
        }
        this.nextHandle();
      } else if (this.curLevelData.questionType === 1) {
        this.submitParams();
      }
    },
    nextHandle() {
      if (this.isLastIndex) {
        this.submitParams();
      } else {
        this.answerIndex += 1;
        this.selectedIndex = [];
        this.answerText = '';
      }
    },
    submitParams() {
      const { id, name } = this.questionnaireInfo;
      const params = {
        questionnaireInfo: {
          id,
          name,
          positionId: this.position,
        },
        answers: this.selectedList.map((i) => i),
      };

      // console.log('最后完成', params, this.levelData);
      this.$service.common.submitQuestionnaire(params).then(() => {
        this.surveyShow = false;
        this.$emit('setAxxSurveyShow', false);
        // console.log(res);
      });
    },
  },
};
</script>
<style lang="less" scoped>
@import "./style.less";
</style>
